import * as React from 'react'

import { Text, View } from '@react-pdf/renderer'
import styles from './Table.style'

interface TableProps {
	medication?: any[]
}

export const TablePrescriptions: React.FC<TableProps> = ({ medication = [] }) => {
	return (
		<View style={styles.container}>
			<Text
				style={[
					styles.td,
					{
						fontFamily: 'Inter',
						fontWeight: `bold`,
						fontSize: 11,
						marginBottom: '2mm',
						marginLeft: '1mm',
					},
				]}
			>
				Items
			</Text>
			{medication.length > 0 &&
				medication
					.filter((med: any) => med !== '')
					.map((med: any, i: number) => {
						const filteredMedication = medication.filter((med: any) => med !== '')
						const isLastItem = i === filteredMedication.length - 1
						return med ? (
							<View
								style={[styles.row, { marginBottom: `1mm`, minHeight: `10mm` }]}
								key={i}
							>
								<View
									style={{
										width: '5mm',
										marginRight: '3mm',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
									}}
								>
									<Text
										style={[
											styles.td,
											{
												textAlign: 'center',
												fontFamily: 'Inter',
												fontWeight: `bold`,
											},
										]}
									>
										{i + 1})
									</Text>
								</View>
								<View
									style={[
										styles.column,
										{
											paddingBottom: `2mm`,
											...(isLastItem
												? {}
												: { borderBottom: `0.5px dashed #cccccc` }),
										},
									]}
								>
									<View style={[styles.row, { marginBottom: '0.5mm' }]}>
										{med?.genericName && (
											<Text
												style={[
													styles?.td,
													{ fontFamily: 'Inter', fontWeight: `bold` },
												]}
											>{`${med?.genericName} `}</Text>
										)}
										{med?.dosage && (
											<Text style={[styles?.td]}>{`${med?.dosage}, `}</Text>
										)}
										{med?.frequency && (
											<Text style={[styles?.td]}>{`${med?.frequency} `}</Text>
										)}
									</View>
									{med?.instructions && (
										<View style={[styles.row]}>
											<Text
												style={[styles?.td, { fontStyle: `italic` }]}
											>{`${med?.instructions} `}</Text>
										</View>
									)}
								</View>
							</View>
						) : (
							<></>
						)
					})}
		</View>
	)
}
